import { FC } from "react";
import { useSelector } from "react-redux";
import { useAppSelector } from "../../store/hooks/StoreHooks";
import { RootState } from "../../store/ConfigureStore";
import EfficiencyCurves from "../calculation-section/pump/pump-plot/efficiency-curves";
import HeadCurves from "../calculation-section/pump/pump-plot/head-curves";
import PowerCurves from "../calculation-section/pump/pump-plot/power-curve";


const PerformanceCurve: React.FC = () => {
    const { isReports } = useAppSelector((state) => state?.reports);
    const { PumpInput, SelectedPump } = useAppSelector(state => state?.pump);
    const { tab3Input } = useAppSelector(state => state?.fluid);
    const { GasFinalCalculatedData } = useAppSelector(state => state?.gasCalculations);
    const { PumpInputCalculated } = useAppSelector((state) => state?.pump);

    return (
        <div className="determine-widget-containers">
            <div className="header-main">
                <div className="flex flex-row justify-between">
                    <div>
                        <h3>DETERMINE performance curves</h3>
                        <h5>Projected performance for the ESP design.</h5>
                    </div>
                </div>
            </div>
            <div className="container-body border-t border-dark flex flex-col gap-2">
                {isReports &&
                    <div className="flex flex-col">
                        <label className="text-[18px] font-semibold text-[#F4FBFC]">Pump performance curve: {SelectedPump?.pumpName}</label>
                        <label className="text-[12px] text-neutral-25 font-normal">{SelectedPump
                            ? `${PumpInput?.pump_DesrdStges} Stages, ${tab3Input?.operatngFreq} Hz - Target conditions: ${GasFinalCalculatedData?.preTFV} bpd at ${PumpInputCalculated?.pmpFinalTDH} ft`
                            : ""}</label>
                    </div>}
                <div className="flex flex-col pl-[200px] pr-[200px]">
                    <EfficiencyCurves />
                </div>
                {isReports &&
                    <div className="flex flex-col">
                        <label className="text-[18px] font-semibold text-[#F4FBFC]">Pump performance curve: {SelectedPump?.pumpName}</label>
                        <label className="text-[12px] text-neutral-25 font-normal">{SelectedPump
                            ? `${PumpInput?.pump_DesrdStges} Stages, ${tab3Input?.operatngFreq} Hz - Target conditions: ${GasFinalCalculatedData?.preTFV} bpd at ${PumpInputCalculated?.pmpFinalTDH} ft`
                            : ""}</label>
                    </div>}
                <div className="flex flex-col pl-[200px] pr-[200px]">
                    <HeadCurves />
                </div>
                <div className="flex flex-col pb-4 mb-4 pl-[200px] pr-[200px]">
                    <PowerCurves />
                </div>
            </div>
        </div>
    )
};

export default PerformanceCurve;
